import { defineStore } from "pinia";
import { useCurationExperienceStore } from "@/features/experience-curation/stores/useCurationExperienceStore";
import { areNonCommercialFieldsEditableForUser } from "@/features/experience-curation/lib/viewTypeUtils";
import { useCurrentExperienceLocationQuery } from "@/features/experience-shared/queries/useExperienceLocationQuery";
import { useHasFunctionalNestedFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";
import { useAddressField } from "@/features/experience-shared/composables/location/useAddressField";

export const useCurationAddress = defineStore("curation-location-address-field", () => {
  const curationExperienceStore = useCurationExperienceStore();
  const locationQuery = useCurrentExperienceLocationQuery();

  const locationData = computed(() => locationQuery.data.value);
  const field = useAddressField(locationData);

  const isReadonly = computed(() => curationExperienceStore.isReadonly || !areNonCommercialFieldsEditableForUser());
  const isVisible = computed(() => !curationExperienceStore.isCommercialView);
  const hasUnpublishedChange = useHasFunctionalNestedFieldChange((f) => ({
    direction: f?.location?.address?.direction,
    postal_code: f?.location?.address?.postal_code,
    country: f?.location?.address?.country,
  }));

  return { ...field, isReadonly, isVisible, hasUnpublishedChange };
});
